<div class="">
	<div class="row">
		<div class="col-lg-6">
			<div class="item-panel">
				<div class="heading">User info</div>
				<div class="content">
					<div class="form-group">
						<label for="smsnumber">SMS Number</label>
						<input [(ngModel)]="smsnumber" name="smsnumber" type="text" class="form-control">
					</div>
					<div class="form-group">
						<app-action-button [action]="UpdateSMS" [context]="this" processing="Updating..." complete="SMS Updated">
							Update</app-action-button>
					</div>
				</div>
			</div>
			<div class="item-panel">
				<div class="heading">Change Password</div>
				<div class="content">
					<form (ngSubmit)="ChangePassword()">
						<div class="form-group">
							<label for="password">Old Password</label>
							<input [(ngModel)]="oldpassword" name="oldpassword" type="password" class="form-control" autocomplete="current-password">
						</div>
						<div class="form-group">
							<label for="password">New Password</label>
							<input [(ngModel)]="newpassword" name="newpassword" type="password" class="form-control" autocomplete="new-password">
						</div>
						<div class="form-group">
							<label for="password">New Password (confirm)</label>
							<input [(ngModel)]="matchpassword" name="matchpassword" type="password" class="form-control" autocomplete="new-password">
						</div>
						<div class="form-group">
							<button type="submit" class="btn btn-success">Change</button>
						</div>
					</form>
					<div *ngIf="passresult" class="message-good">{{passresult}}</div>
					<div *ngIf="passerror" class="message-bad">{{passerror}}</div>
				</div>
			</div>
			<div *ngIf="userOptions" class="item-panel">
				<div class="heading">Multi Factor Authentication</div>
				<div class="content">
					<div class="form-group">
						MFA is: 
						<span *ngIf="userOptions.mfa_enabled" class="message-good">Enabled</span>
						<span *ngIf="!userOptions.mfa_enabled" class="message-bad">Disabled</span>
					</div>
					<div class="form-group">
						<a *ngIf="!userOptions.mfa_enabled" class="btn btn-info" [routerLink]="['../enable-mfa']">Enable MFA</a>
						<a *ngIf="userOptions.mfa_enabled" class="btn btn-info" [routerLink]="['../disable-mfa']">Disable MFA</a>
					</div>
				</div>
			</div>
		</div>
		<div class="col-lg-6">
			<div *ngIf="userOptions" class="item-panel">
				<div class="heading">Mute Notification types</div>
				<div class="content">
					<div *ngIf="!brand.fixedassets" class="row">
						<div class="col-8 form-group">
							Import notifications
						</div>
						<div class="col-4 form-check">
							<label class="form-check-label">
								<input [(ngModel)]="userOptions.mute_imports" class="form-check-input" type="checkbox">
								Mute
							</label>
						</div>
					</div>
					<div class="row">
						<div class="col-8 form-group">
							Device failure notifications
						</div>
						<div class="col-4 form-check">
							<label class="form-check-label">
								<input [(ngModel)]="userOptions.mute_commfails" class="form-check-input" type="checkbox">
								Mute
							</label>
						</div>
					</div>
					<div class="form-group">
						<app-action-button [action]="UpdateNotifications" [context]="this" processing="Updating..." complete="Notification settings updated">
							Update</app-action-button>
					</div>
				</div>
			</div>
			<div *ngIf="notifyorgs && notifyorgs.length > 0" class="item-panel">
				<div class="heading">Asset Notification Subscriptions</div>
				<div class="content">
					<div *ngFor="let org of notifyorgs">
						<div *ngFor="let fleet of org.fleets">
							<h5>{{org.organization_name}} - {{fleet.fleet_name}}</h5>
							<div *ngFor="let asset of fleet.assets" class="row">
								<div class="col-8 form-group">
									{{ asset.asset_name }}<span *ngIf="asset.asset_serial_number"> ({{asset.asset_serial_number}})</span>
								</div>
								<div class="col-2 form-check">
									<label class="form-check-label">
										<input [(ngModel)]="asset.enable_email" class="form-check-input" type="checkbox">
										Email
									</label>
								</div>
								<div class="col-2 form-check">
									<label class="form-check-label">
										<input [(ngModel)]="asset.enable_sms" class="form-check-input" type="checkbox">
										SMS
									</label>
								</div>
							</div>
						</div>
					</div>
					<div class="form-group">
						<app-action-button [action]="UpdateAssets" [context]="this" processing="Updating..." complete="Notifications Updated">Update</app-action-button>
					</div>
				</div>
			</div>
		</div>
	</div>
</div>